import axios from "axios"

const IP_URL = process.env.IP_URL

console.log(IP_URL)

const api = axios.create({
    baseURL: 'https://eu-voce-cristo-backend.onrender.com'
})
export default api